(() => {
  'use strict';
  const mobile = matchMedia('(max-width:768px)');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const galleries = '.pdp-gallery-track,.pg-gallery,.pg-source-gallery,.pg-routine-grid';
  const rows = '.stories,.review-track,.pdp-gallery-track,.pg-gallery,.pg-source-gallery,.pg-routine-grid';
  const stackedRows = '.product-grid,.pg-condition-grid,.pdp-accessories-grid,.pg-collection-grid,.cards3,.pain-list,.steps,.videos,.motion-grid,.lifestyle-grid,.packages,.offer-packages,.utility-grid,.whats,.trust,.pg-detail-cards,.hero,.proof-grid,.pdp-hero,.accessory-hero,.pg-generic-product,.pg-detail-grid,.text-video,.included,.checkout-close,.benefits,.features,.faq-list,.pg-feature-grid,.evidence,.empathy,.guarantee,.offer-block';
  const slides = track => [...track.children].filter(el=>!el.matches('style,script,template,[hidden]'));
  const mounted = new Map();
  let serial = 0;
  const read = el => {try {return JSON.parse(el?.dataset.pgScrollOptions || '{}');} catch {return {};}};
  function setup(track) {
    if (mounted.has(track) || slides(track).length < 2 || track.matches('a,button,form') || track.closest('.pg-native-chrome,.pg-dawn-section')) return;
    const owner = track.dataset.pgScrollOwner === 'section' || track.dataset.pgScrollOverride === 'true'
      ? track : track.parentElement.closest('[data-pg-scroll-owner="section"]') || track;
    const options = read(owner);
    const isGallery=track.classList.contains('pg-gallery-carousel');
    const activeViewport=()=>mobile.matches||track.matches('.pg-condition-images');
    let activeIndex=0,lastWidth=track.clientWidth;
    if (!track.classList.contains('pg-scroll-track')) return;
    const original = {role:track.getAttribute('role'),tabindex:track.getAttribute('tabindex'),label:track.getAttribute('aria-label')};
    track.classList.add('pg-scroll-track');
    const sizing = isGallery ? 'fluid' : options.sizing || 'fluid';
    track.dataset.pgSizing = sizing;
    if(sizing === 'custom')track.style.setProperty('--pg-fixed-card-width',(options.fixedWidth || 340)+'px');
    const controls = document.createElement('div');
    controls.className = 'pg-scroll-controls'; controls.setAttribute('role','group');
    controls.setAttribute('aria-label', (track.dataset.pgScrollLabel || 'Content') + ' navigation');
    if (!track.id) track.id = 'pg-scroll-' + (++serial);
    const vars = {width:(isGallery?100:options.width || 86)+'%',gap:(isGallery?0:options.gap ?? 16)+'px',size:(options.size || 48)+'px',radius:(options.radius ?? 24)+'px',color:options.color,background:options.background,border:options.border,align:{start:'flex-start',center:'center',end:'flex-end'}[options.align] || 'flex-end'};
    for (const [key,value] of Object.entries(vars)) if (value != null) {
      track.style.setProperty('--pg-scroll-'+key,value);controls.style.setProperty('--pg-scroll-'+key,value);
    }
    function button(direction,label) {
      const el = document.createElement('button');el.type = 'button';el.className = 'pg-scroll-button';
      el.setAttribute('aria-label',label);el.setAttribute('aria-controls',track.id);
      const chevron = direction < 0 ? 'M14 5l-7 7 7 7' : 'M10 5l7 7-7 7';
      const arrow = direction < 0 ? 'M20 12H4m7-7-7 7 7 7' : 'M4 12h16m-7-7 7 7-7 7';
      el.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="'+(options.icon === 'arrow' ? arrow : chevron)+'"/></svg>';
      el.addEventListener('click',e => {e.preventDefault();e.stopPropagation();move(direction);});controls.append(el);return el;
    }
    const previous = button(-1,options.previous || 'Previous items');
    const count = document.createElement('output');count.className='pg-scroll-count';count.setAttribute('aria-live','off');controls.append(count);
    const next = button(1,options.next || 'Next items');
    track.after(controls);
    const review = track.closest('.customer-reviews');if(review)review.classList.add('pg-has-mobile-scroll');
    function position() {return Math.abs(track.scrollLeft);}
    function slideOffset(index){const children=slides(track);return children[index].getBoundingClientRect().left-children[0].getBoundingClientRect().left;}
    function move(direction) {
      if(isGallery&&activeViewport()){activeIndex=Math.max(0,Math.min(slides(track).length-1,activeIndex+direction));track.scrollTo({left:slideOffset(activeIndex),behavior:reduced.matches?'auto':'smooth'});return;}
      const children = slides(track);const rtl = getComputedStyle(track).direction === 'rtl';
      const stride = children.length > 1 ? Math.abs(children[1].getBoundingClientRect().left-children[0].getBoundingClientRect().left) : track.clientWidth;
      track.scrollBy({left: direction * (rtl ? -1 : 1) * stride,behavior:reduced.matches ? 'auto' : 'smooth'});
    }
    function update() {
      if(!mobile.matches && sizing === 'desktop'){const first=slides(track)[0];const measured=first?.getBoundingClientRect().width;if(measured>100)track.style.setProperty('--pg-measured-card-width',measured+'px');slides(track).forEach(child=>{const box=child.getBoundingClientRect();if(box.width>100){child.style.setProperty('--pg-preserved-width',box.width+'px');child.style.setProperty('--pg-preserved-height',box.height+'px');}});}
      const end = track.scrollWidth-track.clientWidth;
      const children=slides(track);const edge=track.getBoundingClientRect().left;let active=0,nearest=Infinity;children.forEach((child,index)=>{const distance=Math.abs(child.getBoundingClientRect().left-edge);if(distance<nearest){nearest=distance;active=index;}});if(!isGallery||activeViewport()||end>2)activeIndex=active;count.textContent=(activeIndex+1)+' / '+children.length;
      controls.hidden = !activeViewport() || options.arrows === false || end <= 2;
      previous.disabled = position() <= 2;next.disabled = position() >= end-2;
      if (activeViewport() && end > 2) {
        track.setAttribute('tabindex','0');track.setAttribute('role','region');
        track.setAttribute('aria-label',original.label || track.dataset.pgScrollLabel || 'Scrollable content');
      } else restoreAttributes();
    }
    function resize(){
      const changed=lastWidth!==track.clientWidth;lastWidth=track.clientWidth;
      if(changed&&isGallery&&activeViewport()&&lastWidth>0)track.scrollTo({left:slideOffset(activeIndex),behavior:'auto'});
      update();
    }
    function restoreAttributes() {
      for(const [key,value] of Object.entries({role:original.role,tabindex:original.tabindex,'aria-label':original.label})) {
        if(value === null)track.removeAttribute(key);else track.setAttribute(key,value);
      }
    }
    function onKey(e) {
      if(e.target !== track || !activeViewport() || !['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;
      e.preventDefault();const rtl=getComputedStyle(track).direction==='rtl';
      if(e.key==='Home'||e.key==='End')track.scrollTo({left:e.key==='Home'?0:track.scrollWidth*(rtl?-1:1),behavior:reduced.matches?'auto':'smooth'});
      else move((e.key==='ArrowRight'?1:-1)*(rtl?-1:1));
    }
    track.addEventListener('scroll',update,{passive:true});track.addEventListener('keydown',onKey);
    const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(resize) : null;
    observer?.observe(track);slides(track).forEach(x=>observer?.observe(x));
    mounted.set(track,{update:resize,dispose(){observer?.disconnect();track.removeEventListener('scroll',update);track.removeEventListener('keydown',onKey);restoreAttributes();controls.remove();track.classList.remove('pg-scroll-track');}});
    update();
  }
  function init() {
    // Shopify can re-render a section or its settings; dispose listeners before rebuilding.
    for (const state of mounted.values()) state.dispose();
    mounted.clear();
    document.querySelectorAll(rows+','+stackedRows+',[data-pg-scroll-mode]').forEach(el=>{
      if(el.closest('.pg-native-chrome,.pg-dawn-section') || el.matches('a,button,form'))return;
      let mode=el.dataset.pgScrollMode || 'auto';
      let selected=mode!=='auto';
      const section=el.parentElement?.closest('[data-pg-scroll-owner="section"]');
      const known=el.matches(rows+','+stackedRows);
      const isGallery=el.matches(galleries)&&!el.querySelector(galleries);
      el.classList.toggle('pg-gallery-carousel',isGallery);
      const wrapper=el.matches('.pdp-gallery')||(el.matches(galleries)&&!isGallery)||(el.dataset.pgScrollOwner==='section'&&!known);
      if(wrapper)mode='none';
      else if(mode==='auto'&&known){
        // Explicit choices win. Automatic rows inherit the nearest explicit container/section.
        let parent=el.parentElement;
        while(parent){
          if(parent.matches('[data-pg-scroll-owner]')&&['stack','grid','scroll'].includes(parent.dataset.pgScrollMode)){
            mode=parent.dataset.pgScrollMode;selected=true;break;
          }
          parent=parent.parentElement;
        }
      }
      if(mode==='auto')mode=el.matches(rows)?(slides(el).length>1?'scroll':'stack'):el.matches(stackedRows)?'stack':'none';
      el.dataset.pgEffectiveMode=mode;
      el.dataset.pgLayoutSelected=String(selected);
      el.classList.remove('pg-scroll-track','pg-scroll-stack','pg-scroll-grid');
      if(mode!=='none')el.classList.add(mode==='scroll'?'pg-scroll-track':mode==='grid'?'pg-scroll-grid':'pg-scroll-stack');
      const owner=el.dataset.pgScrollOwner==='section'||el.dataset.pgScrollOverride==='true'?el:section||el;
      const options=read(owner);
      el.style.setProperty('--pg-scroll-gap',(options.gap??16)+'px');
    });
    document.querySelectorAll('.pg-scroll-track').forEach(setup);
  }
  // The editor can replace a theme block without emitting a section load event.
  if(window.Shopify?.designMode && typeof MutationObserver!=='undefined'){
    let queued=false;
    const containsOwner=node=>node.nodeType===1&&(node.matches('[data-pg-scroll-owner]')||node.querySelector('[data-pg-scroll-owner]'));
    new MutationObserver(records=>{
      if(!records.some(record=>record.type==='attributes'||[...record.addedNodes,...record.removedNodes].some(containsOwner)))return;
      if(queued)return;queued=true;
      Promise.resolve().then(()=>{queued=false;init();});
    }).observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['data-pg-scroll-mode','data-pg-scroll-options','data-pg-scroll-override']});
  }
  document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',e=>{
    for(const [track,state] of mounted)if(e.target.contains(track)){state.dispose();mounted.delete(track);}
  });
  document.addEventListener('shopify:block:select',e=>{
    if(!mobile.matches)return;
    const track=e.target.closest('.pg-scroll-track');if(!track)return;
    const card=slides(track).find(child=>child===e.target||child.contains(e.target));
    card?.scrollIntoView({block:'nearest',inline:'start',behavior:'auto'});
  });
  mobile.addEventListener('change',()=>mounted.forEach(state=>state.update()));
  window.addEventListener('resize',()=>mounted.forEach(state=>state.update()),{passive:true});
  init();
})();
